import React, { Component } from "react";
import pubsub from "pubsub-js";
import { Collapse } from "reactstrap";

class SidebarUserBlock extends Component {
  state = {
    userBlockCollapse: false,
    data_user: this.props.User.SideBarConfig.user,
    username: this.props.User.SideBarConfig.UserName,
    userlastmane: this.props.User.SideBarConfig.UserNameLast,
    idRol: this.props.User.SideBarConfig.RoleId,
  };

  componentDidMount() {
    this.pubsub_token = pubsub.subscribe("toggleUserblock", () => {
      this.setState({
        userBlockCollapse: !this.state.userBlockCollapse,
      });
    });
  }

  componentWillUnmount() {
    pubsub.unsubscribe(this.pubsub_token);
  }

  render() {
    let { username, userlastmane, idRol } = this.state;
    // console.log("data_user", username, userlastmane, idRol);

    let RolHandler = { 1: "Administrator", 2: "Customer", 3: "RR", 4: "Agent", 5: "RRSU" };
    return (
      <Collapse id="user-block" isOpen={this.state.userBlockCollapse}>
        <div>
          <div className="item user-block">
            {/* User picture */}
            <div className="user-block-picture">
              <div className="user-block-status">
                <img
                  // className="img-thumbnail rounded-circle"
                  src="https://fsposeidon.blob.core.windows.net/files/user-default-grey.png"
                  alt="Avatar"
                  width="50"
                  height="50"
                />
                <div className="circle bg-success circle-lg"></div>
              </div>
            </div>
            {/* Name and Job */}
            <div className="user-block-info">
              <span className="user-block-name">
                <b>
                  {" "}
                  Hola, {username} {userlastmane}
                </b>
              </span>
              <span className="user-block-role">
                <b>{RolHandler[idRol]}</b>
              </span>
              <hr></hr>
            </div>
          </div>
        </div>
      </Collapse>
    );
  }
}

export default SidebarUserBlock;
